export enum AppErrorEnumeration {
  CHECKOUT_NO_INFO = 'CHECKOUT_NO_INFO',
  CUSTOMER_AUTHORIZATION_FAILED = 'CUSTOMER_AUTHORIZATION_FAILED',
  NO_ONE_TOKEN = 'NO_ONE_TOKEN',
  STATE_FAILED = 'STATE_FAILED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
